import { render, staticRenderFns } from "./TreeEditNotificaciones.vue?vue&type=template&id=4e9fad5e&scoped=true"
import script from "./TreeEditNotificaciones.vue?vue&type=script&lang=js"
export * from "./TreeEditNotificaciones.vue?vue&type=script&lang=js"
import style0 from "./TreeEditNotificaciones.vue?vue&type=style&index=0&id=4e9fad5e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9fad5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9fad5e')) {
      api.createRecord('4e9fad5e', component.options)
    } else {
      api.reload('4e9fad5e', component.options)
    }
    module.hot.accept("./TreeEditNotificaciones.vue?vue&type=template&id=4e9fad5e&scoped=true", function () {
      api.rerender('4e9fad5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/TreeEditNotificaciones.vue"
export default component.exports